// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#no-service-found-container 
{
    margin: 140px 0px;
    padding-bottom: 200px;
}

#no-service-found-title
{
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 25px;
    font-weight: 500;
    color: white;
}

#no-service-found-icon
{
    color: var(--dark-secondary-color);
    background-color: white;
    border-radius: 500px;
}

#no-service-found-text 
{
    text-align: center;
    margin-left: 20px;
}

#no-service-found-description 
{
    margin-top: 20px;
    color: white;
    font-size: 15px;
    text-align: center;
    margin-left: 12px;
    margin-right: 12px;
}

#explore-service-results 
{
    display: flex;
    flex-flow: wrap;
    margin: 0px 20px;
    max-width: 1600px;
    padding-bottom: 200px;
    justify-content: center;
}

.service-result-card
{
    background-color: var(--secondary-color);
    color: white;
    font-weight: 300;
    margin: 40px 20px;
    border-radius: 20px;
    width: 17.5rem;
    cursor: pointer;
    transition: 300ms ease;
    position: relative;
    animation: fadeIn 0.5s;
}

.service-result-card:hover 
{
    background-color: var(--dark-secondary-color);
}

.service-result-button
{
    color: var(--accent-color);
    font-size: 18px;
    font-weight: 600;
    border-radius: 10px;
    cursor: pointer;
    padding: 6px 5px;
    position: absolute;
    bottom: 0;
    text-align: center;
    width: fit-content;
    margin-bottom: 15px;
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    transition: all 0.3s ease-in-out;
}

.service-result-button:hover 
{
    color: white;
    background-color: var(--secondary-color);
}

.service-result-thumbnail 
{
    max-width: 100%;
    max-height: 100%;
    border-radius: 20px;
}

.service-result-title 
{
    color: var(--accent-color);
    margin: 15px 0px;
    font-weight: 600;
    font-size: clamp(18px, 2vw, 23px);
    text-align: center;
    justify-content: center;
    padding: 0px 20px;
    align-items: center;
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    height: 70px;
}

.service-result-author 
{
    margin-bottom: 70px;
    font-size: 15px;
    font-weight: 400;
    padding: 0px 10px;
    display: flex;
    text-align: center;
    justify-content: center;
    overflow: hidden;
    display: -webkit-box;
    text-overflow: ellipsis;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}

@media all and (max-width : 1380px) 
{
    .service-result-card 
    {
        width: 16rem;
    }

    .service-result-author 
    {
        margin-bottom: 60px;
    }

    .service-result-button 
    {
        font-size: 16px;
    }

    .service-result-title
    {
        height: 65px;
    }
}

@media all and (max-width : 988px) 
{
    #explore-service-results 
    {
        margin: 0px 0px;
    }

    .service-result-card
    {
        width: 14rem;
    }

    .service-result-title 
    {
        height: 55px;
    }
}

@media all and (max-width : 850px) 
{

    .service-result-card
    {
        margin: 30px 15px;
    }

    .service-result-author 
    {
        font-size: 15px;
    }
}

@media all and (max-width : 600px) 
{
    .search-picture-container 
    {
        width: 50px;
    }

    .result-text-container 
    {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;
        width: 100%;
    }

    .service-result-card 
    {
        margin: 20px 15px;
        font-size: 14px;
        padding: 0;
        width: 90%;
        display: flex;
        align-items: center;
    }

    .service-result-thumbnail 
    {
        max-width: 200px;
    }

    .service-result-author 
    {
        margin-bottom: 5px;
        font-size: clamp(11px, 2.5vw, 16px);
    }

    .service-result-title 
    {
        margin: 10px 20px;
        padding: 0px 0px;
        width: 100%;
        font-size: clamp(13px, 3vw, 18px);
    }

    .service-result-button
    {
        display: none;
    }
}

@media all and (max-width : 500px) 
{
    .service-result-thumbnail 
    {
        max-width: 140px;
    }

    .service-result-title 
    {
        margin: 10px 10px;
        padding: 0px 10px;
    }

    .service-result-title 
    {
        height: auto;
    }
}

@media all and (max-width : 380px) 
{
    .service-result-title 
    {
        margin: 5px 10px;
    }
}

@media all and (max-width : 350px) 
{
    .service-result-thumbnail 
    {
        max-width: 120px;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/explore-services/main-page.css"],"names":[],"mappings":"AAAA;;IAEI,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA;;IAEI,kCAAkC;IAClC,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;;IAEI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;;IAEI,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;IACrB,uBAAuB;AAC3B;;AAEA;;IAEI,wCAAwC;IACxC,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;;IAEI,6CAA6C;AACjD;;AAEA;;IAEI,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,gCAAgC;AACpC;;AAEA;;IAEI,YAAY;IACZ,wCAAwC;AAC5C;;AAEA;;IAEI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;IAChB,iCAAiC;IACjC,kBAAkB;IAClB,uBAAuB;IACvB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,oBAAoB;IACpB,uBAAuB;IACvB,qBAAqB;IACrB,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;;IAEI,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,uBAAuB;IACvB,gBAAgB;IAChB,oBAAoB;IACpB,uBAAuB;IACvB,qBAAqB;IACrB,4BAA4B;AAChC;;AAEA;;IAEI;;QAEI,YAAY;IAChB;;IAEA;;QAEI,mBAAmB;IACvB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;;QAEI,YAAY;IAChB;AACJ;;AAEA;;IAEI;;QAEI,eAAe;IACnB;;IAEA;;QAEI,YAAY;IAChB;;IAEA;;QAEI,YAAY;IAChB;AACJ;;AAEA;;;IAGI;;QAEI,iBAAiB;IACrB;;IAEA;;QAEI,eAAe;IACnB;AACJ;;AAEA;;IAEI;;QAEI,WAAW;IACf;;IAEA;;QAEI,aAAa;QACb,uBAAuB;QACvB,eAAe;QACf,WAAW;IACf;;IAEA;;QAEI,iBAAiB;QACjB,eAAe;QACf,UAAU;QACV,UAAU;QACV,aAAa;QACb,mBAAmB;IACvB;;IAEA;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,kBAAkB;QAClB,mCAAmC;IACvC;;IAEA;;QAEI,iBAAiB;QACjB,gBAAgB;QAChB,WAAW;QACX,iCAAiC;IACrC;;IAEA;;QAEI,aAAa;IACjB;AACJ;;AAEA;;IAEI;;QAEI,gBAAgB;IACpB;;IAEA;;QAEI,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;;QAEI,YAAY;IAChB;AACJ;;AAEA;;IAEI;;QAEI,gBAAgB;IACpB;AACJ;;AAEA;;IAEI;;QAEI,gBAAgB;IACpB;AACJ","sourcesContent":["#no-service-found-container \n{\n    margin: 140px 0px;\n    padding-bottom: 200px;\n}\n\n#no-service-found-title\n{\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 25px;\n    font-weight: 500;\n    color: white;\n}\n\n#no-service-found-icon\n{\n    color: var(--dark-secondary-color);\n    background-color: white;\n    border-radius: 500px;\n}\n\n#no-service-found-text \n{\n    text-align: center;\n    margin-left: 20px;\n}\n\n#no-service-found-description \n{\n    margin-top: 20px;\n    color: white;\n    font-size: 15px;\n    text-align: center;\n    margin-left: 12px;\n    margin-right: 12px;\n}\n\n#explore-service-results \n{\n    display: flex;\n    flex-flow: wrap;\n    margin: 0px 20px;\n    max-width: 1600px;\n    padding-bottom: 200px;\n    justify-content: center;\n}\n\n.service-result-card\n{\n    background-color: var(--secondary-color);\n    color: white;\n    font-weight: 300;\n    margin: 40px 20px;\n    border-radius: 20px;\n    width: 17.5rem;\n    cursor: pointer;\n    transition: 300ms ease;\n    position: relative;\n    animation: fadeIn 0.5s;\n}\n\n.service-result-card:hover \n{\n    background-color: var(--dark-secondary-color);\n}\n\n.service-result-button\n{\n    color: var(--accent-color);\n    font-size: 18px;\n    font-weight: 600;\n    border-radius: 10px;\n    cursor: pointer;\n    padding: 6px 5px;\n    position: absolute;\n    bottom: 0;\n    text-align: center;\n    width: fit-content;\n    margin-bottom: 15px;\n    margin-left: auto;\n    margin-right: auto;\n    left: 0;\n    right: 0;\n    transition: all 0.3s ease-in-out;\n}\n\n.service-result-button:hover \n{\n    color: white;\n    background-color: var(--secondary-color);\n}\n\n.service-result-thumbnail \n{\n    max-width: 100%;\n    max-height: 100%;\n    border-radius: 20px;\n}\n\n.service-result-title \n{\n    color: var(--accent-color);\n    margin: 15px 0px;\n    font-weight: 600;\n    font-size: clamp(18px, 2vw, 23px);\n    text-align: center;\n    justify-content: center;\n    padding: 0px 20px;\n    align-items: center;\n    overflow: hidden;\n    display: -webkit-box;\n    text-overflow: ellipsis;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    height: 70px;\n}\n\n.service-result-author \n{\n    margin-bottom: 70px;\n    font-size: 15px;\n    font-weight: 400;\n    padding: 0px 10px;\n    display: flex;\n    text-align: center;\n    justify-content: center;\n    overflow: hidden;\n    display: -webkit-box;\n    text-overflow: ellipsis;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n}\n\n@media all and (max-width : 1380px) \n{\n    .service-result-card \n    {\n        width: 16rem;\n    }\n\n    .service-result-author \n    {\n        margin-bottom: 60px;\n    }\n\n    .service-result-button \n    {\n        font-size: 16px;\n    }\n\n    .service-result-title\n    {\n        height: 65px;\n    }\n}\n\n@media all and (max-width : 988px) \n{\n    #explore-service-results \n    {\n        margin: 0px 0px;\n    }\n\n    .service-result-card\n    {\n        width: 14rem;\n    }\n\n    .service-result-title \n    {\n        height: 55px;\n    }\n}\n\n@media all and (max-width : 850px) \n{\n\n    .service-result-card\n    {\n        margin: 30px 15px;\n    }\n\n    .service-result-author \n    {\n        font-size: 15px;\n    }\n}\n\n@media all and (max-width : 600px) \n{\n    .search-picture-container \n    {\n        width: 50px;\n    }\n\n    .result-text-container \n    {\n        display: flex;\n        justify-content: center;\n        flex-wrap: wrap;\n        width: 100%;\n    }\n\n    .service-result-card \n    {\n        margin: 20px 15px;\n        font-size: 14px;\n        padding: 0;\n        width: 90%;\n        display: flex;\n        align-items: center;\n    }\n\n    .service-result-thumbnail \n    {\n        max-width: 200px;\n    }\n\n    .service-result-author \n    {\n        margin-bottom: 5px;\n        font-size: clamp(11px, 2.5vw, 16px);\n    }\n\n    .service-result-title \n    {\n        margin: 10px 20px;\n        padding: 0px 0px;\n        width: 100%;\n        font-size: clamp(13px, 3vw, 18px);\n    }\n\n    .service-result-button\n    {\n        display: none;\n    }\n}\n\n@media all and (max-width : 500px) \n{\n    .service-result-thumbnail \n    {\n        max-width: 140px;\n    }\n\n    .service-result-title \n    {\n        margin: 10px 10px;\n        padding: 0px 10px;\n    }\n\n    .service-result-title \n    {\n        height: auto;\n    }\n}\n\n@media all and (max-width : 380px) \n{\n    .service-result-title \n    {\n        margin: 5px 10px;\n    }\n}\n\n@media all and (max-width : 350px) \n{\n    .service-result-thumbnail \n    {\n        max-width: 120px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
